import { Theme } from './types';

export const getRandomInt = (min: number, max: number): number => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function getArticleTextColor (theme: Theme): string {
  switch (theme) {
    case 'dark': {
      return 'text-white';
    }
    case 'light': {
      return 'text-[#021E60]';
    }
    default: {
      return 'text-[#B9FF00]';
    } // Default text color
  }
}

export function getArticleLinkColor (theme: Theme): string {
  switch (theme) {
    case 'dark': {
      return 'text-white';
    }
    case 'light': {
      return 'text-black';
    }
    default: {
      return 'text-white';
    } // Default text color
  }
}

export function getArticleBackground (theme: Theme): string {
  switch (theme) {
    case 'dark': {
      return '';
    }
    case 'light': {
      return '';
    }
    default: {
      return 'bg-[#00242E]';
    } // Default text color
  }
}

export function getFeatureTextColor (theme: Theme): string {

  switch (theme) {
    case 'dark': {
      return 'text-black';
    }
    case 'light': {
      return 'text-white';
    }
    default: {
      return 'text-white';
    } // Default text color
  }
}

export function getFeatureBorder (theme: Theme): string {

  switch (theme) {
    case 'dark': {
      return 'black';
    }
    case 'light': {
      return 'white';
    }
    default: {
      return 'white';
    } // Default text color
  }
}
